import React, { useEffect, useState } from 'react';
import { getPendingUsers } from '../../../api/admin/userlist/user-list';
import "./Alert.css";

const Alert = ({ onCountChange }) => { // ✅ props로 콜백 받음
  const [pendingUsers, setPendingUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPendingUsers = async () => {
      try {
        const users = await getPendingUsers();
        setPendingUsers(users || []);
        if (onCountChange) onCountChange(users.length); // ✅ 부모에 전달
      } catch (error) {
        console.error('🚨 미승인 유저 조회 실패:', error);
        if (onCountChange) onCountChange(0); // 실패 시 0 전달
      } finally {
        setLoading(false);
      }
    };

    fetchPendingUsers();
  }, [onCountChange]);

  if (loading) return <div className="Alert_Loading">불러오는 중...</div>;
  if (pendingUsers.length === 0) return <div className="Alert_Empty">현재 승인 대기 요청이 없습니다.</div>;

  return (
    <div className="Alert_List">
      {pendingUsers.map((user) => (
        <div key={user.id} className="Alert_Item">
          <span className="Alert_Name">{user.name}</span> 님의 승인대기 요청이 있습니다.
        </div>
      ))}
    </div>
  );
};

export default Alert;
